import Route from '@ember/routing/route';
import protectedRoute from 'lumen/utils/decorators/protected-route';

@protectedRoute({ features: ['spider.revpak_library'] })
export default class HotelRevpakExportsRoute extends Route {
  model() {
    return this.modelFor('hotel');
  }
}
